export const getAuthFromLocalStorage = () => {
    try {
        const result = localStorage.getItem("auth");
        const {authenticationToken} = JSON.parse(result);
        if (authenticationToken) {
            return {
                token: authenticationToken.token,
                userId: authenticationToken.userId,
                role: authenticationToken.role,
            };
        } else {
            const {token, userId, role} = JSON.parse(result);
            return {token, userId, role};
        }
    } catch (err) {
        throw new Error("There is no token in local storage");
    }
};

export const getTokenFromLocalStorage = () => {
    try {
        const result = localStorage.getItem("auth");
        const {authenticationToken} = JSON.parse(result);
        if (authenticationToken) {
            return {
                token: authenticationToken.token,
            };
        } else {
            const {token} = JSON.parse(result);
            return {token};
        }
    } catch (err) {
        throw new Error("There is no token in local storage");
    }
};

export const loadUserFromLocal = () => {
    try {
        const serializedState = localStorage.getItem("auth");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};